import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
  root: {
    '& .MuiOutlinedInput-input': {
      padding: 10.5,
      width: 100,
    },
  },
  table: {
    minWidth: 650,
  },
});

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix=""
      decimalScale="2"
      fixedDecimalScale
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default function CuentasConfirma(props) {
  const { titulosColumnas, cuentasParaPago, pagosSugeridos, pagosIngresados, erroresPagos, onEditPayment } = props;
  const [editPayment, setEditPayment] = React.useState(pagosSugeridos);
  const [errorPayment, setErrorPayment] = React.useState(erroresPagos);
  const [paySuggested] = React.useState(pagosIngresados);
  const [totalPayment, setTotalPayment] = React.useState(parseFloat('0.00').toFixed(2));
  const classes = useStyles();
  const { t } = useTranslation(['translation', 'pagos']);
  // console.log('cuentasParaPago',cuentasParaPago)
  const handleChange = (e, cuenta) => {
    let newPayments = new Map();
    let erroresPagos = new Map();
    editPayment.forEach((v, k) => {
      if (k === cuenta) {
        newPayments.set(k, e.target.value);
        erroresPagos.set(k, "");
        setTotalPayment(parseFloat('0.00').toFixed(2));
        if (e.target.value === "") {
          erroresPagos.set(k, t('pagos:montoinvalido'));
        } else {
          const cuentaPago = cuentasParaPago.find(c => c.accountNumber === cuenta);
          if (e.target.value > cuentaPago.maxPayment) {
            erroresPagos.set(k, t('pagos:montomax'));
          } else if (e.target.value < cuentaPago.minPayment) {
            erroresPagos.set(k, t('pagos:montomin'));
          } else {
            // console.log('e.target.value', e.target.value)
            // console.log('cuentaPago.fee', cuentaPago.fee)
            // console.log('total', parseFloat(e.target.value) + parseFloat(cuentaPago.fee))
            setTotalPayment(parseFloat(parseFloat(e.target.value) + parseFloat(cuentaPago.fee)).toFixed(2));
          }
        }
      } else {
        erroresPagos.set(k, errorPayment.get(k));
        newPayments.set(k, editPayment.get(k));
      }
    });
    setEditPayment(newPayments);
    setErrorPayment(erroresPagos);
    onEditPayment(newPayments, erroresPagos);
  };


  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
              {titulosColumnas.map(tituloColumna =>(
                <TableCell
                  key={tituloColumna.id}
                  align={'left'}
                >
                  {tituloColumna.label}
                </TableCell>
              ))}
          </TableRow>
        </TableHead>  
        <TableBody>
          {cuentasParaPago.map((row) => (
            <TableRow key={row.accountNumber}>
              <TableCell component="th" scope="row" align="left">
                {row.accountNumber}
              </TableCell>
              <TableCell align="left">{row.productName}</TableCell>
              <TableCell align="left">{row.customerName}</TableCell>
              <TableCell align="left">$ {paySuggested.get(row.accountNumber)}</TableCell>
              <TableCell align="left">
                <TextField
                  className={classes.root}
                  error={errorPayment.get(row.accountNumber) !== ""}
                  helperText={errorPayment.get(row.accountNumber)}
                  label={t('pagos:pagomonto')}
                  value={editPayment.get(row.accountNumber)}
                  onChange={e => handleChange(e, row.accountNumber)}
                  name="numberformat"
                  variant="outlined"
                  InputProps={{
                    inputComponent: NumberFormatCustom,
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                  }}
                  
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Typography color="secondary" variant="h6" className={classes.instructions} style={{marginLeft: '15px'}}>TOTAL: $ {totalPayment}</Typography>

    </TableContainer>
  );
}
